export function getModelPath(type, id) {
  return `/models/${type}s/${type}_${id}.glb`;
}

export function getPreviewImagePath(type, id) {
  return `/images/previews/${type}s/${type}_${id}_preview.png`;
}

export function getFallbackImagePath(type, id) {
  return `/images/${type}s/${type}_${id}.png`;
}
